// AUTO-GENERATED by tools/generate-world5-b.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world5-b.mjs
// W5 part B (L11-L20) — second pass, harder profile, different seed region.
import type { LevelDef } from '@tessera/engine';

export const WORLD_5B_GENERATED: LevelDef[] = [
  // d*=6  branching=14.55  D=0.065  tiles=11
  {
    id: 'w5-l11',
    world: 5,
    index: 11,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    ],
  },
  // d*=6  branching=19.83  D=0.158  tiles=11
  {
    id: 'w5-l12',
    world: 5,
    index: 12,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=20.32  D=0.161  tiles=11
  {
    id: 'w5-l13',
    world: 5,
    index: 13,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 2 },
    ],
  },
  // d*=6  branching=20.42  D=0.161  tiles=11
  {
    id: 'w5-l14',
    world: 5,
    index: 14,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 2 },
    ],
  },
  // d*=6  branching=20.64  D=0.163  tiles=11
  {
    id: 'w5-l15',
    world: 5,
    index: 15,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=21.15  D=0.164  tiles=11
  {
    id: 'w5-l16',
    world: 5,
    index: 16,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=20.89  D=0.164  tiles=11
  {
    id: 'w5-l17',
    world: 5,
    index: 17,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=17.90  D=0.167  tiles=11
  {
    id: 'w5-l18',
    world: 5,
    index: 18,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=19.02  D=0.168  tiles=11
  {
    id: 'w5-l19',
    world: 5,
    index: 19,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=21.68  D=0.168  tiles=11
  {
    id: 'w5-l20',
    world: 5,
    index: 20,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
];
